import EditDialog from "@/components/common/EditDialog";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { useMessageHistoryCopy } from "@/features/i18n/messageHistoryCopy";
import { ui } from "@patient-watch/ui";
import { cn } from "@/lib/utils";
import { useAreAllNotificationsDisabled, usePreferencesQuery } from "../api/preferencesQuery";
import PreferencesForm from "./PreferencesForm";

const PreferencesCard = () => {
    const copy = useProfileCopy();
    const messageCopy = useMessageHistoryCopy();
    const { data } = usePreferencesQuery();
    const preferences = data ?? {};
    const noPreferences = data == null || Object.keys(preferences).length === 0;
    const notificationsDisabled = useAreAllNotificationsDisabled();

    const channelStatus = (enabled: boolean | undefined) =>
        enabled ? copy.notificationsEnabled : copy.notificationsDisabled;

    return (
        <section className="mb-4">
            <ui.Card className={cn(notificationsDisabled && "border-red-300")}>
                <ui.CardHeader className="pb-0">
                    <ui.CardTitle className="text-xl">{copy.notificationPreferences}</ui.CardTitle>
                </ui.CardHeader>
                <ui.CardContent className="py-2">
                    <EditDialog
                        triggerTestId="preferences-edit-button"
                        dialogTitle={copy.notificationPreferences}
                        dialogDescription={copy.notificationPreferencesDescription}
                        noInfo={noPreferences}
                        info={
                            <span className="flex flex-col gap-1 text-lg">
                                <span>
                                    {messageCopy.channelEmail}: {channelStatus(preferences.channel_types?.email)}
                                </span>
                                <span>
                                    {messageCopy.channelSms}: {channelStatus(preferences.channel_types?.sms)}
                                </span>
                            </span>
                        }
                    >
                        <PreferencesForm />
                    </EditDialog>
                </ui.CardContent>
            </ui.Card>
        </section>
    );
};

export default PreferencesCard;
